import { connect, ConnectedProps } from 'react-redux';
import { DATA_FETCHING_STATUS } from 'src/redux/data/constants';

import {
  selectors as emrSchedullingFrequencySelectors,
  actions as emrSchedullingFrequencyActions,
} from 'src/redux/data/emrSchedullingFrequency';
import { RootState } from 'src/redux/store';

const mapStateToProps = (state: RootState) => {
  return {
    emrFrequencySettingsData:
      emrSchedullingFrequencySelectors.selectEmrSchedullingFrequency(state),
    isEmrFrequencyLoading:
      emrSchedullingFrequencySelectors.selectEmrSchedullingFrequencyStatus(
        state,
      ) === DATA_FETCHING_STATUS.LOADING,
  };
};

const mapActionCreators = {
  getEmrSchedullingFrequncyByOperatorId:
    emrSchedullingFrequencyActions.getEmrSchedullingFrequncyByOperatorId,
  createEmrSchedullingFrequncyByOperatorId:
    emrSchedullingFrequencyActions.createEmrSchedullingFrequncyByOperatorId,
  editEmrSchedullingFrequncyByOperatorId:
    emrSchedullingFrequencyActions.editEmrSchedullingFrequncyByOperatorId,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
